import Client from '../HttpClient';

const baseUrl = '/gateway/numbat-api/api/vs/manager';

const list = (merchantId) => {
	return Client.get(`${baseUrl}/${merchantId}/branchs`);
};

const find = (merchantId, branchId) => {
	return Client.get(`${baseUrl}/${merchantId}/branchs/${branchId}`);
};

const update = (merchantId, branchId, payload) => {
	return Client.put(`${baseUrl}/${merchantId}/branchs/${branchId}`, payload);
};

const sort = (merchantId, payload) => {
	return Client.put(`${baseUrl}/${merchantId}/branchs/sort`, payload);
};

const getSecret = (merchantId, branchId, payload) => {
	return Client.post(
		`${baseUrl}/${merchantId}/branchs/secureKey/${branchId}`,
		payload
	);
};

const updateAttendance = (merchantId, branchId, payload) => {
	return Client.put(
		`${baseUrl}/${merchantId}/${branchId}/staff-data-collection/on-off`,
		payload
	);
};

export default {
	list,
	find,
	update,
	sort,
	getSecret,
	updateAttendance,
};
